export const getTotalDuration = (storageType) => {
    let totalDuraction
    if(storageType === "local"){
      totalDuraction= new Date().getTime() - localStorage.getItem("localStartTime")
    }else if(storageType === "session"){
      totalDuraction= new Date().getTime() - sessionStorage.getItem("sessionStartTime")
    }
    return totalDuraction
  };

  export const redirectToSubUrl = (sub_url, rcid, camp,game_id,game_category) => {
    let redirect_url= `${sub_url}?sid=${localStorage.getItem("sessionId")}`
    const rc_id =
      localStorage.getItem("rcid") || sessionStorage.getItem("rcid") || rcid;
    const camp_id =
      localStorage.getItem("camp") || sessionStorage.getItem("camp") || camp;
    if (rc_id) {
      redirect_url += "&rcid=" + rc_id;
    }
    if (camp_id) {
      redirect_url += "&camp=" + camp_id;
    }
    if (game_id) {
      redirect_url += "&id=" + game_id;
    }
    if (game_category) {
      redirect_url += "&cat=" + game_category;
    }
    console.log("redirect_url::", redirect_url);
    window.open(redirect_url, "_self");
  };